import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=template&id=22630dae&scoped=true"
import script from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22630dae",
  null
  
)

export default component.exports